
import * as print from './print';

export default {
    print
}
